module.exports = __webpack_public_path__ + "img/search-icon.77a96f6a.svg";